import { IFormSettings } from '@tf/formbuilder'
import { useFormConfig } from 'hooks/useFormConfig'

export const FormWrapper = (controls: any, formMeta: any) => {
	useFormConfig()
	return {
		controls: controls,
		formMeta: formMeta,
	} as unknown as IFormSettings
}
